
export const CustomSidebar = ({ rol, children }) => {
  return <>{children}</>;
};
